import {Cureus} from '../Cureus';

Cureus.Howto = {};

//= require_tree ./Howto
